/**
 * DebugSettings - Global debug settings for the game
 * Toggle various debug features on/off
 */

export class DebugSettings {
  private static instance: DebugSettings;

  // Debug flags - ALL DISABLED for clean gameplay
  public enablePhysicsLogging: boolean = false;
  public enableCollisionLogging: boolean = false;
  public enableAILogging: boolean = false;
  public enableAudioLogging: boolean = false;
  public enableInputLogging: boolean = false;
  public showFPS: boolean = false;
  public noclip: boolean = false;

  private constructor() {}

  public static getInstance(): DebugSettings {
    if (!DebugSettings.instance) {
      DebugSettings.instance = new DebugSettings();
    }
    return DebugSettings.instance;
  }

  /**
   * Toggle physics logging on/off
   */
  public togglePhysicsLogging(): void {
    this.enablePhysicsLogging = !this.enablePhysicsLogging;
    console.log(`🔧 Physics Logging: ${this.enablePhysicsLogging ? 'ENABLED' : 'DISABLED'}`);
  }

  /**
   * Toggle collision logging on/off
   */
  public toggleCollisionLogging(): void {
    this.enableCollisionLogging = !this.enableCollisionLogging;
    console.log(`💥 Collision Logging: ${this.enableCollisionLogging ? 'ENABLED' : 'DISABLED'}`);
  }

  /**
   * Toggle AI logging on/off
   */
  public toggleAILogging(): void {
    this.enableAILogging = !this.enableAILogging;
    console.log(`🤖 AI Logging: ${this.enableAILogging ? 'ENABLED' : 'DISABLED'}`);
  }

  /**
   * Toggle audio logging on/off
   */
  public toggleAudioLogging(): void {
    this.enableAudioLogging = !this.enableAudioLogging;
    console.log(`🔊 Audio Logging: ${this.enableAudioLogging ? 'ENABLED' : 'DISABLED'}`);
  }

  /**
   * Toggle input logging on/off
   */
  public toggleInputLogging(): void {
    this.enableInputLogging = !this.enableInputLogging;
    console.log(`⌨️ Input Logging: ${this.enableInputLogging ? 'ENABLED' : 'DISABLED'}`);
  }

  /**
   * Toggle all logging on/off
   */
  public toggleAllLogging(): void {
    const newState = !this.enablePhysicsLogging;
    this.enablePhysicsLogging = newState;
    this.enableCollisionLogging = newState;
    this.enableAILogging = newState;
    this.enableAudioLogging = newState;
    this.enableInputLogging = newState;
    console.log(`🎛️ All Logging: ${newState ? 'ENABLED' : 'DISABLED'}`);
  }

  /**
   * Toggle noclip on/off
   */
  public toggleNoclip(): void {
    this.noclip = !this.noclip;
    console.log(`👻 Noclip: ${this.noclip ? 'ENABLED' : 'DISABLED'}`);
  }

  /**
   * Disable all logging
   */
  public disableAllLogging(): void {
    this.enablePhysicsLogging = false;
    this.enableCollisionLogging = false;
    this.enableAILogging = false;
    this.enableAudioLogging = false;
    this.enableInputLogging = false;
    console.log(`🔇 All Logging DISABLED`);
  }
}

// Export singleton instance
export const debugSettings = DebugSettings.getInstance();
